export default __webpack_public_path__ + "8b8638ee09964b639e3c702fc23d3003.jpg";